function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_310_23705)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.74994 5.5C6.19794 5.5 5.74994 5.052 5.74994 4.5V1C5.74994 0.448 6.19794 0 6.74994 0C7.30194 0 7.74994 0.448 7.74994 1V4.5C7.74994 5.052 7.30194 5.5 6.74994 5.5Z",
  fill: "#525A6E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5 5.5C10.948 5.5 10.5 5.052 10.5 4.5V1C10.5 0.448 10.948 0 11.5 0C12.052 0 12.5 0.448 12.5 1V4.5C12.5 5.052 12.052 5.5 11.5 5.5Z",
  fill: "#525A6E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2501 5.5C15.6981 5.5 15.2501 5.052 15.2501 4.5V1C15.2501 0.448 15.6981 0 16.2501 0C16.8021 0 17.2501 0.448 17.2501 1V4.5C17.2501 5.052 16.8021 5.5 16.2501 5.5Z",
  fill: "#525A6E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2499 2.25H4.74994C3.23294 2.25 1.99994 3.483 1.99994 5V21.25C1.99994 22.767 3.23294 24 4.74994 24H18.2499C19.7669 24 20.9999 22.767 20.9999 21.25V5C20.9999 3.483 19.7669 2.25 18.2499 2.25ZM6.99994 8H11.9999C12.5519 8 12.9999 8.448 12.9999 9C12.9999 9.552 12.5519 10 11.9999 10H6.99994C6.44794 10 5.99994 9.552 5.99994 9C5.99994 8.448 6.44794 8 6.99994 8ZM16.9999 18H6.99994C6.44794 18 5.99994 17.552 5.99994 17C5.99994 16.448 6.44794 16 6.99994 16H16.9999C17.5519 16 17.9999 16.448 17.9999 17C17.9999 17.552 17.5519 18 16.9999 18ZM16.9999 14H6.99994C6.44794 14 5.99994 13.552 5.99994 13C5.99994 12.448 6.44794 12 6.99994 12H16.9999C17.5519 12 17.9999 12.448 17.9999 13C17.9999 13.552 17.5519 14 16.9999 14Z",
  fill: "#525A6E"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_310_23705"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

function SvgDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.3a1acae4.svg";
export { ForwardRef as ReactComponent };